
/**
 * Created by SH on 28/7/2019.
 */

import { ReelSymbolStates } from "../ReelSpriteSymbolArea";
import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { AssetLoader } from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import { ISymbolConfig, ISymbolDim, ISymbolNormalState, ISymbolStateData, ISymbolMultiState, SymValue, SymValueData, BasicSymbolType } from "./IReelSymbolStruct";
import {PunkRocker} from "../../../../game/PunkRocker";
import {PRGameMode} from "../../../../game/server/PRGameMode";

export class SymbolData {

    private static symbolValues: SymValue;

    protected static configs: ISymbolConfig[] = [];
    protected static enableLogg: boolean = false;
    protected static assetLoader: AssetLoader;

    protected static defaultDim: ISymbolDim;
    protected preDefinedSymbols: ISymbolConfig[];

    public static getAllConfigs():ISymbolConfig[]{
        return this.configs;
    }

    public static get DEFAULT_DIM(): ISymbolDim {
        return this.defaultDim;
    }

    constructor(assetLoader: AssetLoader, symDim:ISymbolDim, logs?:boolean) { 
        SymbolData.assetLoader = assetLoader; 
        SymbolData.enableLogg = !!logs;
        SymbolData.defaultDim = symDim;
    }

    public static SymbolWinValues(symName: string): SymValueData {
        return SymbolData.symbolValues[symName];
    }

    public parseInitDataForInit(data: any): SymbolData {

        SymbolData.symbolValues = data.symbolValues;

        let symbolNames: string[] = Object.keys(data.symbolValues).map((symbolName: string) => { return symbolName }).concat(this.preDefinedSymbols.map(d => { return d.NAME }));

        this.addSymbolData(symbolNames);

        this.InitSymbolData();

        return this;
    }

    protected InitSymbolData(): void {
        const keyNames: string[] = Object.keys(PIXI.utils.TextureCache).filter(function (path: string) {
            const splitted: string = path.split("/")[0];
            return (splitted.length > 0 && splitted.length < 4) && splitted !== "ui";
        }).filter((v =>{
            const nrSections:number = v.split("/").length;
            return v.split("/")[0] === v.split("/")[nrSections-1].split("_")[0];
        }));
        
        for (let i = 0; i < keyNames.length; i++) {
            for (let j = 0; j < SymbolData.configs.length; j++) {
                if (keyNames[i].split("/")[0] == SymbolData.configs[j].NAME) {
                    if (keyNames[i].split("/").length > 2) {
                        if (SymbolData.configs[j].MULTI_STATES == undefined)
                            SymbolData.configs[j].MULTI_STATES = {};

                        let ID: string = keyNames[i].split("/")[1];
                        let stateType: string = keyNames[i].split("/")[2].split("_")[1];
                        if(!stateType) stateType = ReelSymbolStates.NORMAL;
                        
                        let State: ISymbolMultiState = {};

                        State[ID] = {};
                        State[ID][stateType] = { TEXTURE_PATH: keyNames[i], DIM: SymbolData.defaultDim };
                        
                        if (Object.keys(SymbolData.configs[j].MULTI_STATES!).find(key => key == ID)) {
                            let Statearr: ISymbolNormalState[] | { [TYPE: string]: ISymbolStateData } = SymbolData.configs[j].MULTI_STATES![ID] as { [TYPE: string]: ISymbolStateData };
                            if(Statearr[stateType] && Statearr[stateType].DIM) State[ID][stateType].DIM = Statearr[stateType].DIM;
                            if(Statearr[stateType] && Statearr[stateType].STACKED_SIZE) State[ID][stateType].STACKED_SIZE = Statearr[stateType].STACKED_SIZE;
                            Statearr[stateType] = State[ID][stateType];
                            SymbolData.configs[j].MULTI_STATES![ID] = Statearr;
                        }
                        else if (SymbolData.configs[j].MULTI_STATES) {
                            SymbolData.configs[j].MULTI_STATES![ID] = State[ID];

                        } else {
                            SymbolData.configs[j].MULTI_STATES! = State;
                        }
                    } else {
                        let stateType: string = keyNames[i].split("/")[1].split("_")[1];
                        if (stateType == undefined) stateType = ReelSymbolStates.NORMAL;

                        if (SymbolData.configs[j].NORMAL_STATES) {
                            let deffState: ISymbolNormalState[] | { [TYPE: string]: ISymbolStateData } = SymbolData.configs[j].NORMAL_STATES! as { [TYPE: string]: ISymbolStateData };
                            deffState[stateType] = { TEXTURE_PATH: keyNames[i],
                                 DIM: deffState[stateType] && deffState[stateType].DIM ? deffState[stateType].DIM : SymbolData.defaultDim,
                                 STACKED_SIZE: deffState[stateType] ? deffState[stateType].STACKED_SIZE : undefined
                            };
                            SymbolData.configs[j].NORMAL_STATES! = deffState;
                        } else {
                            let State: ISymbolNormalState = {};
                            State[stateType] = { TEXTURE_PATH: keyNames[i], DIM: SymbolData.defaultDim };
                            SymbolData.configs[j].NORMAL_STATES! = State;
                        }
                    }
                }
            }
        }
    }

    protected addSymbolData(arr: string[]): void {
        arr.forEach(symName => {
            if(SymbolData.getConfig(symName).NAME == "")
                SymbolData.configs.push(this.createSymbolData(symName));
        });
    }

    public static getConfig(symName: string): ISymbolConfig {
        let objFetch: ISymbolConfig | undefined = undefined;

        for (let i = 0; i < this.configs.length; i++) if (this.configs[i].NAME == symName) objFetch = this.configs[i];

        if (objFetch) return objFetch;

        this.enableLogg && Logger.warn("Tried to find an undefined symbol: " + symName);
        this.enableLogg && Logger.warn("Returning emptyNamed symbol");
        return { NAME: "" }
    }

    private static fetchSymbolStateData(config: ISymbolConfig, state: string, multiState?: string):ISymbolStateData | undefined{
        let stateData:ISymbolStateData | undefined; 

        if (config.MULTI_STATES) {
            if (config.MULTI_STATES[multiState!]) {
                stateData = (config.MULTI_STATES[multiState!] as { [TYPE: string]: ISymbolStateData })[state];
            }
            else this.enableLogg && Logger.warn("Missing MultiStates: " + multiState + " for symbol: " + config.NAME);
        }
        else if (config.NORMAL_STATES) {
            stateData = (config.NORMAL_STATES![state] as ISymbolStateData);
        }else{
            this.enableLogg && Logger.warn("The "+ config.NAME +" have no stateData.");
        }
        return stateData;
    }

    protected static findTexturePath(config: ISymbolConfig, state: string, multiState?: string): string | undefined {
        let stateData:ISymbolStateData | undefined = this.fetchSymbolStateData(config,state,multiState); 

        if (stateData) {
            //#125 feedbacks
            if(config.NAME === "S1" && PunkRocker.model.gameData.mode === PRGameMode.RESPIN && state === ReelSymbolStates.NORMAL) {
                stateData = this.fetchSymbolStateData(config,"riot",multiState)!;
            }

            return stateData.TEXTURE_PATH;
        } else {
            this.enableLogg && Logger.warn("Missing state:" + state + ", for symbol: " + config.NAME);
            (state != ReelSymbolStates.NORMAL) && this.enableLogg && Logger.warn("Trying to fetch normal state instead.");
            return (state == ReelSymbolStates.NORMAL) ? undefined : this.findTexturePath(config, ReelSymbolStates.NORMAL, multiState);
        }
    }

    public static getDimFromConfig(config: ISymbolConfig, state: string, multiState?: string): ISymbolDim | undefined {
        let stateData:ISymbolStateData | undefined = this.fetchSymbolStateData(config,state,multiState);

        if (stateData) 
            return stateData.DIM;
        else {
            this.enableLogg && Logger.warn("Missing state:" + state + ", for symbol: " + config.NAME);
            this.enableLogg && Logger.log("Missing state:" + state + ", for symbol: " + config.NAME);
            this.enableLogg && console.log(config);
            this.enableLogg && Logger.log("SIZE TYPE: " + multiState);
            return (state == ReelSymbolStates.NORMAL) ? undefined : this.getDimFromConfig(config, ReelSymbolStates.NORMAL, multiState);
        } 
    }

    public static getStackedValue(config: ISymbolConfig, state: string, multiState?: string): number {
        let stateData:ISymbolStateData | undefined = this.fetchSymbolStateData(config,state,multiState); ; 

        if (stateData) 
            return stateData.STACKED_SIZE != undefined ? stateData.STACKED_SIZE : 1;
        else {
            this.enableLogg && Logger.warn("Missing state:" + state + ", for symbol: " + config.NAME);
            return 1;
        } 
    }

    public static isLowSymbol(name: string): boolean {
        return name.length > 1 && name[0] == "L" && !isNaN(parseFloat(name[1]));
    }

    public static isHighSymbol(name: string): boolean {
        //return name.length > 1 && (name[0] == "M" || name[0] == "XWILD") && !isNaN(parseFloat(name[1]));
        return name.length > 1 && (name[0] == "M") && !isNaN(parseFloat(name[1]));
    }

    public static isNormalSymbol(name:string):boolean{
        return this.isLowSymbol(name) || this.isHighSymbol(name);
    }

    public static getTextures(symName: string, state: string, multiState?: string): PIXI.Texture[] | undefined {
        const res: string | undefined = this.findTexturePath(SymbolData.getConfig(symName), state, multiState);
        return res ? SymbolData.assetLoader.getTextures(res) : undefined;
    }

    private createSymbolData(symType: string): ISymbolConfig {
        let newSymData: ISymbolConfig;
        for (var i = 0; i < this.preDefinedSymbols.length; i++) {
            if (this.preDefinedSymbols[i].NAME == symType) {
                if (this.preDefinedSymbols[i].MULTI_STATES) {
                    newSymData = { NAME: symType, MULTI_STATES: this.preDefinedSymbols[i].MULTI_STATES }
                } else if(this.preDefinedSymbols[i].NORMAL_STATES) {
                    newSymData = { NAME: symType, NORMAL_STATES: this.preDefinedSymbols[i].NORMAL_STATES }
                }else{
                    newSymData = { NAME: symType }
                }
                return newSymData;
            }
        }
        return {
            NAME: symType,
        }
    }
}